import * as ReactGA from 'react-ga';

export const initGA = (id) => {
  ReactGA.initialize(id);
};
